<template>
	<div>
		<van-nav-bar title="账户与安全"  fixed placeholder left-arrow @click-left="onClickLeft" />
		
		<ih-panel :url="url2" text="实名认证" content="用于查看修改实名认证身份信息" @click.native="realname" ></ih-panel>
		<ih-panel :url="url3" text="司机认证" content="用于查看修改司机认证身份信息" @click.native="drivercertification" ></ih-panel>
		<ih-panel :url="url" text="修改个人信息" content="用于修个人资料信息" @click.native="topersonalInfo"></ih-panel>
		<ih-panel v-for="(item, key) in panelList" @click.native="toRoute(item.route)" :url="item.url" :text="item.text"
			:content="item.content" :key="key"></ih-panel>
		<ih-panel :url="url4" text="修改密码" content="设置AiHao智控账号登录密码" @click.native="changePassword"></ih-panel>
		<div class="assess-box">
			版本号：5.2.3
		</div>
	</div>
</template>
<script>
	import {
		NavBar
	} from "vant";
	import ihPanel from "@/components/ihPanel";
	export default {
		name: "accountSafe",
		data() {
			return {
				url: require("@/assets/icon/Rectangle(5).png"),
				url2: require("@/assets/sm.png"),
				url3: require("@/assets/sj.png"),
				url4: require("@/assets/mm.png"),
				panelList: [
					// {
					//   url: require("@/assets/icon/Rectangle(5).png"),
					//   text: "修改个人信息",
					//   content: "用于修个人资料信息",
					//   route: "personalInfo"
					// },
					{
						url: require("@/assets/icon/Rectangle(6).png"),
						text: "修改手机号",
						content: "用于修改AiHao智控登录手机号",
						route: "modifymobilephone"
					},
					// {
					//   url: require("@/assets/icon/Rectangle(7).png"),
					//   text: "修改密码",
					//   content: "设置AiHao智控账号登录密码",
					//   route: "changePassword"
					// },
					// {
					//   url: require("@/assets/icon/Rectangle(4).png"),
					//   text: "设备管理",
					//   content: "用于解除设备绑定"
					// }
				]
			};
		},
		components: {
			ihPanel,
			"van-nav-bar": NavBar
		},
		created() {
			console.log(this.$route.params);
		},
		methods:{
			topersonalInfo() {
				if (localStorage.getItem("identify") == "engineer") {
					this.$router.push({
						name: "personalInfogcs",
						params: {
							returtlist: "1"
						},
					});
				} else {
					this.$router.push({
						name: "personalInfo",
						params: {
							returtlist: "1"
						},
					});
				}

			},
			// 实名认证 
			realname() {
				window.open("app:/#/getIdCardIdentify")
			},
			//司机认证
			drivercertification() {
				window.open("app:/#/getDriverIdentify")

			},
			onClickLeft() {
				window.open("app:/#/finish")
			},
			//修改密码
			changePassword() {
				window.open("app:/#/edit_password")
			},
			toRoute(name) {
				this.$router.push({
					name
				});
			}
		}
	};
</script>

<style scoped>
	.assess-box{
		position: absolute;
		left: 40%;
		bottom: 15%;
		font-size: 12px;
	}
</style>
